import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import { Tab, Tabs, Typography } from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { styled } from "@mui/material/styles";
import productTabsData from "../../data/EltPageModules.json"

const PREFIX = "ETLModuleTabs";

const classes = {
  productTabLabel: `${PREFIX}-productTabLabel`,
  productTabSelected: `${PREFIX}-productTabSelected`,
  backgroundDesign2: `${PREFIX}-backgroundDesign2`,
  exploreProductLink: `${PREFIX}-exploreProductLink`,
  tabContainerBlock: `${PREFIX}-tabContainerBlock`,
  buttonContainer: `${PREFIX}-buttonContainer`,
  productTabsContainer: `${PREFIX}-productTabsContainer`,
  productTabsDesc: `${PREFIX}-productTabsDesc`,
  tabContainerTabs: `${PREFIX}-tabContainerTabs`,
  productImage: `${PREFIX}-productImage`,
  productImageCoreCommand: `${PREFIX}-productImageCoreCommand`,
  productImageOtherThanCoreCommand: `${PREFIX}-productImageOtherThanCoreCommand`,
  exploreAnchorLink: `${PREFIX}-exploreAnchorLink`,
  root: `${PREFIX}-root`,
  smsPoints: `${PREFIX}-smsPoints`,
  smsPointItem: `${PREFIX}-smsPointItem`,
  productGrid: `${PREFIX}-productGrid`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.root}`]: {
    "& .MuiGrid2-root": {
      padding: "0 24px 0 40px",
    },
  },
  [`& .${classes.productTabsContainer}`]: {
    padding: "0 24px 0 40px",
    [theme.breakpoints.down("sm")]: {
      padding: 0,
    },
  },
  [`& .${classes.backgroundDesign2}`]: {
    backgroundColor: "#fefbfb",
  },
  [`& .${classes.tabContainerTabs}`]: {
    // marginLeft: "0.5em",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  [`& .${classes.productTabLabel}`]: {
    textTransform: "capitalize",
    fontSize: 25,
    fontFamily: "AvenirLTStd-Roman",
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: {
      paddingRight: "1em",
      fontSize: 20,
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 25,
    },
    [theme.breakpoints.between("md", "lg")]: {
      fontSize: 28,
    },
  },
  [`& .${classes.productTabSelected}`]: {
    color: "#000 !important",
  },
  [`& .${classes.tabContainerBlock}`]: {
    paddingTop: "0", 
    paddingBottom: "24px",
    paddingLeft: "24px",
    paddingRight: "24px",
    [theme.breakpoints.down("sm")]: {
      padding: "0 0 1em 0 !important",
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 30,
    },
    [theme.breakpoints.between("md", "lg")]: {
      fontSize: 35,
    },
  },
  [`& .${classes.productImage}`]: {
    minHeight: 200,
    minWidth: 200,
    maxWidth: "initial",
    [theme.breakpoints.down("sm")]: {
      width: 500,
      height: "auto",
      marginTop: "1em",
    },
  },
  [`& .${classes.productImageCoreCommand}`]: {
    height: 500,
    width: 700,
    [theme.breakpoints.down("sm")]: {
      width: 390,
      height: "auto",
      maxWidth: "inherit",
      marginTop: "1em",
    },
    [theme.breakpoints.between("sm", "lg")]: {
      width: 400,
      height: 300,
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: "initial",
    },
  },
  [`& .${classes.productImageOtherThanCoreCommand}`]: {
    height: 500,
    width: 600,
    [theme.breakpoints.down("sm")]: {
      width: 390,
      height: "auto",
      maxWidth: "inherit",
      marginTop: "1em",
    },
    [theme.breakpoints.between("sm", "lg")]: {
      width: 360,
      height: 400,
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: "initial",
    },
  },
  [`& .${classes.productTabsDesc}`]: {
    padding: "1em",
    fontFamily: "AvenirLTStd-Book",
    fontSize: 23,
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 25,
    },
    [theme.breakpoints.between("md", "lg")]: {
      fontSize: 25,
    },
  },
  [`& .${classes.exploreProductLink}`]: {
    textAlign: "left",
    padding: "1em 1em 1em 1.5em",
    [theme.breakpoints.down("sm")]: {
      padding: "0 1em",
    },
  },
  [`& .${classes.exploreAnchorLink}`]: {
    textDecoration: "none",
    color: "#B41E1C",
    fontFamily: " AvenirLTStd-Roman",
    fontSize: 26,
    fontWeight: 700,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.2rem",
    },
    "@media (min-width: 375px)": {
      fontSize: 18,
    },
    "@media (min-width: 800px)": {
      fontSize: 26,
    },
    "@media (min-width: 1280px)": {
      fontSize: 30,
    },
  },
  [`& .${classes.smsPoints}`]: {
    listStyleType: "none",
    paddingLeft: "2rem",
  },
  [`& .${classes.smsPointItem}`]: {
    display: "flex",
    alignItems: "center",
    marginBottom: "0.5em",
    fontSize: 20,
    fontWeight: 100,
    color: "#223140",
    fontFamily: "AvenirLTStd-Book",
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 20,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 20,
    },
    "& svg": {
      color: "#c20d0b",
      marginRight: "0.5em",
    },
  },
  [`& .${classes.productGrid}`]: {
  display: "flex",
  alignSelf: "flex-start",
  flexDirection: "column",
  }
}));



const EtlModuleTab = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, value) => {
    setValue(value);
  };

  return (
    <StyledGrid container>
      <Grid
        size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        className={[classes.productTabsContainer, classes.productTabsDesc].join(
          " "
        )}
      >
        <Tabs
          value={value}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          variant="scrollable"
          classes={{ indicator: "product-tabs-indicator" }}
          className={classes.tabContainerTabs}
        >
          {productTabsData &&
            productTabsData.map((item, index) => {
              return (
                <Tab
                  key={index}
                  label={
                    <span className={classes.productTabLabel}>
                      {item.id === "journeyLog" ? "Journey Log" : item.title}
                    </span>
                  }
                  sx={{
                    "&.Mui-selected": {
                      color: "#000",
                      textTransform: "capitalize",
                      textAlign: "start",
                      alignItems: "flex-start",
                      padding: "12px 8px",
                      fontSize: 25,
                    },
                  }}
                />
              );
            })}
        </Tabs>

        {productTabsData &&
          productTabsData.map((item, index) => {
            return (
              value === index && (
                <Typography
                  component="div"
                  key={index}
                  className={classes.tabContainerBlock}
                >
                  <Grid container className="product-tab-container" style={{ alignItems: "flex-start", marginTop: "1%" }}>
                    <Grid
                      size={{ xs: 12, sm: 6, md: 6, lg: 6 }}
                      className={classes.productGrid}
                    >
                      <span className="product-content-border-top" />
                      <Typography
                        variant="h4"
                        className={classes.productTabsDesc}
                        style={{ fontWeight: 'bold' }}
                      >
                        {item.id === "journeyLog" ? (
                          <>
                            Journey Log - <span style={{ color: '#c20d0b' }}>REDiFly Pilot</span>
                          </>
                        ) : (
                          item.title
                        )}
                      </Typography>
                      <Typography
                        variant="body1"
                        className={classes.productTabsDesc}
                      >
                        {item.description}
                      </Typography>
                      <ul className={classes.smsPoints}>
                        {item.points.map((point, pointIndex) => (
                          <li key={pointIndex} className={classes.smsPointItem}>
                            <ArrowForwardIcon sx={{color: "#c20d0b", fontSize: "20px"}}/>
                            {point}
                          </li>
                        ))}
                      </ul>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }} sx={{display: "flex", justifyContent: "center", alignItems: "flex-start"}}>
                      <img
                        alt="product"
                        className={[
                          classes.productImage,
                          item.id === "core" || item.id === "command"
                            ? classes.productImageCoreCommand
                            : classes.productImageOtherThanCoreCommand,
                        ].join(" ")}
                        src={item.image}
                      />
                    </Grid>
                  </Grid>
                </Typography>
              )
            );
          })}
      </Grid>
    </StyledGrid>
  );
};

export default EtlModuleTab;
